var _circle, _path, _path2, _path3, _path4, _path5, _circle2, _circle3, _circle4, _circle5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharacters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 535,
    height: 354,
    viewBox: "0 0 535 354",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 482.173,
    cy: 206.351,
    r: 34.5775,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M428.391 153.635C445.661 153.635 461.164 161.2 471.77 173.196C476.147 171.192 481.015 170.073 486.145 170.073C505.241 170.074 520.722 185.554 520.722 204.651C520.722 208.602 520.056 212.398 518.836 215.935C528.286 224.245 534.252 236.424 534.252 249.998C534.252 275.043 513.949 295.346 488.904 295.346H394.241C369.197 295.346 348.895 275.043 348.895 249.998C348.895 233.654 357.542 219.332 370.51 211.352C370.599 179.461 396.479 153.635 428.391 153.635Z",
    fill: "url(#paint0_linear_468_2156)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M458.937 206.827C457.768 204.126 456.336 200.134 451.197 199.202C446.058 198.269 443.498 202.781 442.77 206.796",
    stroke: "#111928",
    strokeWidth: 4.89623,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M408.561 205.677C409.726 203.79 410.799 199.688 415.98 199.031C421.162 198.374 423.645 202.495 424.707 206.509",
    stroke: "#111928",
    strokeWidth: 4.89623,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M447.48 219.676C446.35 223.618 441.492 231.196 431.098 229.973C427.57 229.609 419.9 226.78 417.445 218.372",
    stroke: "#111928",
    strokeWidth: 4.89623,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M103.762 146.617C125.262 146.617 142.691 164.046 142.691 185.546V256.402C142.691 277.902 125.262 295.331 103.762 295.331C90.2354 295.331 78.322 288.431 71.3447 277.96C64.3673 288.431 52.4549 295.331 38.9287 295.331C17.4288 295.331 0 277.902 0 256.402V185.547C0 164.047 17.4288 146.617 38.9287 146.617C52.4544 146.617 64.3672 153.517 71.3447 163.987C78.3221 153.516 90.2358 146.618 103.762 146.617Z",
    fill: "url(#paint1_linear_468_2156)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.8065,
    cy: 213.064,
    r: 12.9764,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.8076,
    cy: 213.064,
    r: 5.14936,
    fill: "#111928"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.7088,
    cy: 213.064,
    r: 12.9764,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.7099,
    cy: 213.064,
    r: 5.14936,
    fill: "#111928"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M202.019 146.617C237.44 146.617 266.409 174.24 268.561 209.12H268.691V283.488C268.691 289.977 263.431 295.236 256.942 295.236H147.099C140.61 295.236 135.35 289.977 135.35 283.488V213.574C135.349 213.479 135.348 213.383 135.348 213.287C135.348 213.191 135.349 213.096 135.35 213V209.12H135.477C137.628 174.24 166.597 146.617 202.019 146.617Z",
    fill: "url(#paint2_linear_468_2156)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M226.045 207.559C225 205.145 223.72 201.577 219.127 200.743C214.534 199.91 212.245 203.943 211.594 207.531",
    stroke: "#111928",
    strokeWidth: 4.37641,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M181.015 206.531C182.056 204.845 183.015 201.178 187.647 200.591C192.278 200.003 194.498 203.687 195.447 207.274",
    stroke: "#111928",
    strokeWidth: 4.37641,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M215.803 219.044C214.793 222.567 210.45 229.34 201.16 228.247C198.006 227.922 191.151 225.393 188.956 217.879",
    stroke: "#111928",
    strokeWidth: 4.37641,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M298.306 153.635C304.738 142.496 320.816 142.496 327.248 153.635L339.452 174.773H363.86C376.723 174.773 384.762 188.698 378.331 199.837L366.126 220.975L378.33 242.112C384.761 253.251 376.722 267.176 363.859 267.176H339.452L327.249 288.313C320.817 299.452 304.739 299.452 298.307 288.313L286.104 267.176H261.695C248.832 267.176 240.793 253.251 247.224 242.112L259.429 220.973L247.225 199.837C240.794 188.698 248.833 174.773 261.696 174.773H286.102L298.306 153.635Z",
    fill: "url(#paint3_linear_468_2156)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M337.105 202.928C336.061 205.341 334.781 208.91 330.188 209.743C325.594 210.577 323.306 206.544 322.655 202.956",
    stroke: "#111928",
    strokeWidth: 4.37641,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M292.076 203.956C293.117 205.642 294.076 209.309 298.707 209.896C303.338 210.483 305.558 206.799 306.507 203.212",
    stroke: "#111928",
    strokeWidth: 4.37641,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M326.863 219.823C325.853 223.347 321.511 230.12 312.22 229.027C309.067 228.702 302.211 226.173 300.017 218.658",
    stroke: "#111928",
    strokeWidth: 4.37641,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M318.383 84.1375C318.383 52.8774 293.042 27.5361 261.781 27.5361H236.322C205.062 27.5361 179.721 52.8774 179.721 84.1375V84.1375C179.721 115.398 205.062 140.739 236.322 140.739H261.781C293.042 140.739 318.383 115.398 318.383 84.1375V84.1375Z",
    fill: "#FFE6FD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M284.104 153.691C286.672 154.808 289.485 152.726 289.168 149.944L285.602 118.649C285.285 115.867 282.076 114.472 279.825 116.137L254.506 134.873C252.255 136.538 252.651 140.016 255.219 141.132L284.104 153.691Z",
    fill: "#FFE6FD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M219.033 90.2434L237.825 69L259.014 95.3781L274.326 72.8258",
    stroke: "#FFA4F7",
    strokeWidth: 13.189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M499.528 56.7973C499.973 55.3467 502.027 55.3467 502.472 56.7973V56.7973C504.341 62.89 509.11 67.6592 515.203 69.5283V69.5283C516.653 69.9733 516.653 72.0267 515.203 72.4717V72.4717C509.11 74.3408 504.341 79.11 502.472 85.2027V85.2027C502.027 86.6533 499.973 86.6533 499.528 85.2027V85.2027C497.659 79.11 492.89 74.3408 486.797 72.4717V72.4717C485.347 72.0267 485.347 69.9733 486.797 69.5283V69.5283C492.89 67.6592 497.659 62.89 499.528 56.7973V56.7973Z",
    fill: "#E8DED1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4403 6.71408C38.0631 4.68395 40.9369 4.68395 41.5597 6.71409L42.4772 9.70486C45.0932 18.2321 51.7679 24.9068 60.2951 27.5228L63.2859 28.4403C65.316 29.0631 65.316 31.9369 63.2859 32.5597L60.2951 33.4772C51.7679 36.0932 45.0932 42.7679 42.4772 51.2951L41.5597 54.2859C40.9369 56.316 38.0631 56.316 37.4403 54.2859L36.5228 51.2951C33.9068 42.7679 27.2321 36.0932 18.7049 33.4772L15.7141 32.5597C13.6839 31.9369 13.684 29.0631 15.7141 28.4403L18.7049 27.5228C27.2321 24.9068 33.9068 18.2321 36.5228 9.70486L37.4403 6.71408Z",
    fill: "#E8DED1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 270.5,
    cy: 343,
    rx: 189.5,
    ry: 11,
    fill: "#E8DED1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_468_2156",
    x1: 441.573,
    y1: 153.635,
    x2: 441.573,
    y2: 295.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABD8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_468_2156",
    x1: 71.3457,
    y1: 146.617,
    x2: 71.3457,
    y2: 295.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EA56F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29B95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_468_2156",
    x1: 202.02,
    y1: 146.617,
    x2: 202.02,
    y2: 295.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E26012"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_468_2156",
    x1: 312.778,
    y1: 145.281,
    x2: 312.778,
    y2: 296.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBA65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD880"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacters);
export default __webpack_public_path__ + "static/media/characters.585443c6735a8fd5d9030bfc2f8e125a.svg";
export { ForwardRef as ReactComponent };